/**
 * Product Innovation Lab - KPI Types
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business KPI型定義。メトリクス・目標・達成率・ダッシュボード設定
 * @graph-connects none
 */
import { ACE_SUB_TEAMS as ACE_SUB_TEAM_KEYS, TET_SUB_TEAMS as TET_SUB_TEAM_KEYS, } from '@cortex/domain-product-innovation-lab-combat-power-scope';
/**
 * ACE group 配下のサブチームを表す KpiTeam の部分集合。
 *
 * KPI ビューでは `ace` を親、この 4 チームを子として扱う（`TEAM_HIERARCHY` と同じ括り）。
 * 「ACE 各チームビューだけに適用する」処理（例: 開発pt / リリース数の MTD 目標線をチーム単位で
 * 算出する）が、リテラル配列を各所で再宣言せず本定数を参照できるようにしている。
 *
 * 識別子の正本は combat-power-scope 側（同パッケージが ACE サブチームの team_name / メンバー
 * nick_name も持つ SSOT で、かつ本パッケージが combat-power-scope に依存しているため逆向きの
 * import は循環になる）。ここでの `satisfies readonly KpiTeam[]` が **2 パッケージ間の定義ズレの
 * 検出点**で、combat-power-scope 側に `KpiTeam` に無いキーが増えればコンパイルで落ちる。
 *
 * PDG 側の子チーム（tet / sre）は目標線の口径が異なる（tet は PDG 予算から SRE を差し引く
 * 減算方式）ため、この集合には含めない。
 * @graph-connects @cortex/domain-product-innovation-lab-combat-power-scope [references] ACE サブチーム識別子の正本 (ACE_SUB_TEAMS)
 */
export const ACE_SUB_TEAMS = ACE_SUB_TEAM_KEYS;
/**
 * PDG TE 配下のサブチームを表す `KpiTeam` の部分集合。
 *
 * `ACE_SUB_TEAMS` と同じく識別子の正本は combat-power-scope 側にあり、ここでの
 * `satisfies readonly KpiTeam[]` が 2 パッケージ間の定義ズレの検出点になる。
 *
 * ACE サブチームとの違いは解決方法で、ACE は team_name が実在するのに対し TE サブチームは
 * `team_name='pi-tet'` のまま nick_name で割る（`TET_TEAM_MEMBER_NICKNAMES` が名簿の正本）。
 * @graph-connects @cortex/domain-product-innovation-lab-combat-power-scope [references] TE サブチーム識別子の正本 (TET_SUB_TEAMS)
 */
export const TET_SUB_TEAMS = TET_SUB_TEAM_KEYS;
/**
 * `KpiTeam` が ACE サブチームかを判定する type guard。
 * ACE 各チームビュー専用の分岐（目標線の算出等）で使う。
 * @graph-connects none
 */
export function isAceSubTeam(team) {
    return ACE_SUB_TEAMS.includes(team);
}
/**
 * `KpiTeam` が PDG TE サブチームかを判定する type guard。
 * TE サブチームだけ nick_name 条件を重ねる分岐で使う。
 * @graph-connects none
 */
export function isTetSubTeam(team) {
    return TET_SUB_TEAMS.includes(team);
}
//# sourceMappingURL=kpi.js.map